/**
 * Product Form Components
 *
 */
 class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (this.form) {
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartElement = document.querySelector('ajax-cart');
      this.sparePartsCheck();
      this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
      this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }
  }
  
  sparePartsCheck() {
    const sparePartsContainer = this.closest('.js-spareParts');
    if(sparePartsContainer) {
      let addEl = sparePartsContainer.querySelectorAll('.js-spareAdd');
      let sparePartsEl = sparePartsContainer.querySelectorAll('.js-spareInput');
      sparePartsEl.forEach(spareParts => {
        spareParts.addEventListener('change', () => {
          sparePartsContainer.querySelectorAll('.js-spareInput[type="checkbox"]:checked').length > 0
            ? addEl.forEach(add => add.removeAttribute('disabled'))
            : addEl.forEach(add => add.setAttribute('disabled', true));
        })
      })
    }
  }

  _pixelsEvent(addedItems) {
    try {
      addedItems.map(addedItem => {
        const props = addedItem.properties;
        const qtyAdded = parseFloat(addedItem.quantity);
        if(props.product_handle !== undefined){
        fetch(`${window.location.origin}/products/${props.product_handle}.json`)
            .then(res => res.clone().json().then(r => {
              if (r.product) {
                const product = r.product;
                const variant = product.variants.find(v => v.id === parseInt(props.product_id))

                let variantTitle = '';
                if (product.variants.length > 1) {
                  if (variant.option1) {
                    variantTitle += ' - ' + variant.option1
                  }
                  if (variant.option2) {
                    variantTitle += ' - ' + variant.option2
                  }
                  if (variant.option3) {
                    variantTitle += ' - ' + variant.option3
                  }
                }

                let atcEventData = {
                  name: `${product.title}${variantTitle}`,
                  productID: variant.id,
                  url: `${window.location.origin}/products/${addedItem.properties.product_handle}?variant=${variant.id}`,
                  imageURL: product.image ? product.image.src : '',
                  price: `$${variant.price}`,
                  compareAtPrice: `${variant.compare_at_price ? `$${variant.compare_at_price}` : ''}`,
                  brand: product.vendor,
                  categories: product.product_type,
                }

                //klaviyo
                window.klaviyo.push(['track', 'Added to Cart', atcEventData]);
                console.log(`klaviyo Added to Cart data:`);
                console.log(atcEventData);

                //bing
                const bingEventData = {
                  ecomm_prodid: [atcEventData.productID],
                  ecomm_pagetype: 'product',
                  currency: 'USD',
                  event_category: atcEventData.categories,
                  event_label: atcEventData.name,
                  event_value: parseFloat(variant.price),
                  items: [
                    {
                      id: atcEventData.productID,
                      quantity: qtyAdded,
                      price: parseFloat(variant.price),
                    }
                  ]
                };
                window.uetq = window.uetq || [];
                window.uetq.push('event', 'add_to_cart', bingEventData);
                console.log(`bing add_to_cart data:`);
                console.log(bingEventData);
              }
            }));
          }
      })
    } catch (e) {}
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const addOnItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const submitSubscription = this.querySelector('.js-subscribe');
    const subscribe = evt.submitter.classList.contains('js-subscribe');
    const qtyInput = this.querySelector('[data-qty-input]');
    const pdpContainer = this.closest('.product-details-wrapper');
    const sparePartsContainer = this.closest('.js-spareParts');
    let replacementNote;
    let cartNote = window.globalVariables.cart.note;
    let replacementButtons;
    
    try{
      let verifyEmail = this.querySelector('#rc_gift_recipient_email_confirm')
      let email = this.querySelector('#rc_gift_recipient_email');

      if(verifyEmail.value !== email.value) {
        verifyEmail.classList.add('error-border');
        return
      }
    }catch{}

    if(subscribe) {
      submitSubscription.setAttribute('disabled', true);
      submitSubscription.classList.add('loading');
    }
    else{
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
    }

    if(!sparePartsContainer){
      if(subscribe){
        addItems.push(JSON.parse(serializeForm(this.form)))
      }else{
        addItems.push(JSON.parse(serializeForm(this.form, 'selling_plan')))
      }
    }

    if(pdpContainer){
      let addOnItemsEle = pdpContainer.querySelectorAll('[data-addon-selection]:checked');
      addOnItemsEle.forEach((addOn)=>{
        if(addOn.disabled == false){
          let addOnParent = addOn.closest('addons-form');
          let addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value
          }
          addItems.push(addOnJSON);
        }
      });
    }
    if(sparePartsContainer) {
      let spareParts = sparePartsContainer.querySelectorAll('[data-spare-parts]:checked');
      let spareTitle = sparePartsContainer.querySelector('form').getAttribute('data-title');
      replacementButtons = document.querySelectorAll('.js-spareAdd');
      replacementNote = document.querySelector('#replacement').value || '';


      console.log(replacementNote, 'replacementNotes')
      spareParts.forEach((sparePart)=>{
        if(sparePart.disabled == false){
          let addOnJSON = {
            id: sparePart.value,
            quantity: "1",
            properties: {
              "_replacement_parts": spareTitle
            }
          }
          addItems.push(addOnJSON);
        }
      });
    }

    window.globalVariables.cart.note?.includes(replacementNote) 
      ? ''
      : cartNote = replacementNote;


    const body = JSON.stringify({
      items: addItems,
      note: cartNote
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this._pixelsEvent(addItems)
        this.cartElement.getCartData('open_drawer');
        if(qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(subscribe) {
          submitSubscription.removeAttribute('disabled');
          submitSubscription.classList.remove('loading');
        }
        else{
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
        }
      try{
          replacementButtons.forEach(button => {
            button.classList.remove('loading')
          })
        }catch{}
        try{
          document.querySelectorAll(".modal.open").forEach(ele => {
            ele.classList.remove("open");
        })}catch{}
      });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let qtyContainer = currentTarget.closest('[data-qty-container]');
    let qtyInput = qtyContainer.querySelector('[data-qty-input]');
    let currentQty = parseInt(qtyInput.value) || 1;
    let finalQty = currentQty;
  
    if (action == 'decrease') {
      if (currentQty <= 1) {
        return false; 
      }
      finalQty = currentQty - 1;
    } else if (action == 'increase') {
      finalQty = currentQty + 1;
    }
  
    qtyInput.value = finalQty;
  
    // Update button classes based on the new quantity
    this.updateDecreaseButtonState(qtyContainer, finalQty);
  }
  
  updateDecreaseButtonState(qtyContainer, quantity) {
    const decreaseBtn = qtyContainer.querySelector('[data-for="decrease"]');
    if (quantity <= 1) {
      decreaseBtn.classList.add('disabled');
    } else {
      decreaseBtn.classList.remove('disabled');
    }
  }  
}
customElements.define('product-form', ProductForm);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.notify_me = this.form.querySelector('.notify-me-btn');

    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;

    if(this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    this.setCurrentVariant();

    if(this.formType === 'product-page'){
      window.globalVariables.product.currentVariant = this.currentVariant;
      const productSKU = document.querySelector('[name="product_sku"]');
      if(productSKU) {
        productSKU.value = this.currentVariant.sku;
      }
    }

    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      // Variant name update
      let options = this.form.querySelectorAll('[data-optionindex]');
      options.forEach(option => {
        let lableID = 'option'+option.dataset.optionindex;
        const selectedValue = option.querySelector('input[type="radio"]:checked');
        const lable = option.querySelector('.selected-option');
        if(!lable || !lableID || !selectedValue) return;
        lable.innerHTML = selectedValue.value;
      });
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid);
      }else{
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }
  }

  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      console.log(href, 'what is this');
      link.href = href + variantURL;
    });
  }

  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    const options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
    return options;
  }

  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
        return;
      }
    });
  }

  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if (this.formType === 'product-page') {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', currentVariant.id);
      if (this.dataset?.url) {
        url.pathname = new URL(this.dataset.url, url.origin).pathname;
      }
      window.history.replaceState({}, '', url.toString());
    }


    console.log(window.history, `${this.dataset.url}?variant=${currentVariant.id}`, 'hello');
    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;

    let sku = this.form.querySelector('input[name="product_sku"]');
    if(sku) sku.value = currentVariant.sku;

    let currentVariantID = this.form.querySelector('input[name="_product_id"]');
    if (currentVariantID) currentVariantID.value = currentVariant.id;

    let product_sku = this.form.querySelector('input[name="properties[product_sku]"]');
    if (product_sku) product_sku.value = currentVariant.sku;

    let product_id = this.form.querySelector('input[name="properties[_product_id]"]');
    if (product_id) product_id.value = currentVariant.id;

  }

  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;

    // Price Update
    let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
    let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if(priceElement) priceElement.innerHTML = price;
    if(comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if(currentVariant.compare_at_price <= 0){
        comparePriceElement.style.display = 'none';
      }else{
        comparePriceElement.style.display = 'block';
      }
    }

    // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let lableID = 'option'+option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if(!lable || !lableID) return;
      lable.innerHTML = currentVariant[lableID];
    });

    // Grid Image Update on variant selection
    if(this.formType == 'grid'){
      if(!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if(updatedSrc){
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    }else{
      if(!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(`.product--media[data-mediaID="${imageID}"]`);
      if(!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      if(productSlider) productSlider.slideTo(slideIndex, 2000, true);
    }

  }

  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
      if(this.notify_me){
        this.addBtn.classList.remove('d-none');
        this.notify_me.classList.add('d-none');
      }
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'));
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
      if(this.notify_me){
        this.addBtn.classList.add('d-none');
        this.notify_me.classList.remove('d-none');
      }
    } else {
      this.addBtn.removeAttribute('disabled');
      this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      if(this.notify_me){
        this.addBtn.classList.remove('d-none');
        this.notify_me.classList.add('d-none');
      }
    };
  }

  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }
  }
}
customElements.define('variant-radios', VariantRadios);